
export const data = [
  {
    id:1,
    title: `Performance<br/> Marketing Analyst:`,
    image:"https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lidlg.png",
    desc:"You'll be constantly analyzing campaign performance, tweaking ads, testing new strategies, and ensuring you get the best return on your ad spend."
    
  },
  {
    id:2,
    title: `Digital Marketing<br/> Analyst:`,
    image:"https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lidlg.png",
    desc:"Your day will revolve around diving into data, creating reports, tracking KPIs, and presenting insights to improve your marketing efforts."
    
  },
  {
    id:3,
    title: "Marketing Associate:",
    image:"https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lidlg.png",
    desc:"You'll assist in planning and executing campaigns, coordinating with different teams, creating content, and managing social media."
    
  },{
    id:4,
    title: "Brand Executive:",
    image:"https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lidlg.png",
    desc:"You'll manage brand campaigns, ensure consistency across all channels, collaborate with creative teams, and analyze market trends to strengthen your brand identity."
    
  },{
    id:5,
    title: `Growth Marketing<br/> Executive:`,
    image:"https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lidlg.png",
    desc:"Your day will focus on identifying growth opportunities, running experiments, optimizing user acquisition strategies, and analyzing data to drive business growth."
    
  },
  {
    id:6,
    title: "SEO Analyst:",
    image:"https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lidlg.png",
    desc:"You'll conduct keyword research, optimize web pages, monitor website traffic, and implement strategies to improve our search engine rankings."
    
  }
];
